import { get } from './get';

/**
 * Searches for {stateKey} in a string and returns the string, with content replaced from state.
 * @param {String} label - The label or inner html.
 * @returns {Function} A method that returns the string with keys interpolated with data from substate.
 */
export const interpolateString = (label) => {
    return (state) => {
        if (!label) {
            return label;
        }

        return label.replace(/{([^{}]*)}/g, (replacement, stateKey) => {
            const r = get(state, stateKey);
            return typeof r === 'string' || typeof r === 'number' ? r : '';
        });
    };
};

/**
 * Map the application state to rest arguments set in the schema.
 * @param {Object} state - the application's state / store
 * @param {Object} restArgs - the rest arguments.
 * @returns {Object} state mapped to rest arguments.
 */
export const mapStateToArgs = (state, restArgs = []) => {
    return restArgs.map((obj) => {
        const value = get(state, obj.identifier, obj.value) || null;
        return { ...obj, value };
    });
};
